import { connect, type ConnectedProps } from 'react-redux';
import { type RootState } from 'src/reducers';
import mediator from 'Utilities/mediator';

import AccountInfoAdult from './AccountInfoAdult';
import { notifyApp } from 'Utilities/appCommunicator';

const mapStateToProps = ({ auth }: RootState) => ({
  patient: auth.include.patient,
});

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector>;

const AccountInformation = ({ patient }: Props) => {
  const onBack = () => {
    mediator.publish('router:back');
    notifyApp('adc-webview:navigate-back-app');
  };

  return <AccountInfoAdult patient={patient} onBack={onBack} />;
};

export default connector(AccountInformation);
